import { DividerProps } from "./types";

import { twMerge } from "tailwind-merge";

const Divider = ({ isVertical }: DividerProps) => {
  return (
    <span
      className={twMerge(
        "appearAnimation before:content-[' '] after:content-[' '] flex gap-[0.4375rem] text-[0.875rem] leading-normal text-neutral-800 before:bg-neutral-300/50 after:bg-neutral-300/50 dark:text-white/75 dark:before:bg-white/20 dark:after:bg-white/20",
        isVertical
          ? "w-[1.125rem] flex-col items-center justify-center before:h-full before:w-[1px] after:h-full after:w-[1px]"
          : "h-[1.125rem] items-center before:h-[1px] before:w-full after:h-[1px] after:w-full",
      )}
    >
      or
    </span>
  );
};

export default Divider;
